// extracted by mini-css-extract-plugin
export default {"container":"styles_container__4sEkR","darkbar":"styles_darkbar__j0SCw","header":"styles_header__h8b+L","scrollable":"styles_scrollable__jYg23"};